import { render, staticRenderFns } from "./InvestedLanding.vue?vue&type=template&id=37c921dc&scoped=true&"
import script from "./InvestedLanding.vue?vue&type=script&lang=js&"
export * from "./InvestedLanding.vue?vue&type=script&lang=js&"
import style0 from "./InvestedLanding.vue?vue&type=style&index=0&id=37c921dc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c921dc",
  null
  
)

component.options.__file = "InvestedLanding.vue"
export default component.exports